import React, { useMemo, useState } from 'react';
import { TreeItem, TreeView } from '@mui/lab';
import { Tooltip } from '@mui/material';
import { Trash } from "../../../../components/icons";
import { DotsIcon } from "../../../dashboard/icons";

import ImageGallery from '../visual/EditorMenu/ImageGallery';

import "./tabs.scss";

const FolderIcon = () => <svg style={{ minWidth: 20 }} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M4.16667 3.33594H7.5L10 5.83594H15.8333C16.2754 5.83594 16.6993 6.01153 17.0118 6.32409C17.3244 6.63665 17.5 7.06058 17.5 7.5026V14.1693C17.5 14.6113 17.3244 15.0352 17.0118 15.3478C16.6993 15.6603 16.2754 15.8359 15.8333 15.8359H4.16667C3.72464 15.8359 3.30072 15.6603 2.98816 15.3478C2.67559 15.0352 2.5 14.6113 2.5 14.1693V5.0026C2.5 4.56058 2.67559 4.13665 2.98816 3.82409C3.30072 3.51153 3.72464 3.33594 4.16667 3.33594" stroke="#555D67" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
</svg>;

const CirclePlusIcon = () => <svg style={{ minWidth: 20 }} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M10 17.5C14.1421 17.5 17.5 14.1421 17.5 10C17.5 5.85786 14.1421 2.5 10 2.5C5.85786 2.5 2.5 5.85786 2.5 10C2.5 14.1421 5.85786 17.5 10 17.5Z" stroke="#6A3CE2" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  <path d="M7.5 10H12.5" stroke="#6A3CE2" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  <path d="M10 7.5V12.5" stroke="#6A3CE2" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
</svg>;

const PureFileIcon = () => <svg style={{ minWidth: 20 }} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M11.6666 2.5V5.83333C11.6666 6.05435 11.7544 6.26631 11.9107 6.42259C12.067 6.57887 12.2789 6.66667 12.5 6.66667H15.8333" stroke="#555D67" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  <path d="M14.1666 17.5H5.83329C5.39127 17.5 4.96734 17.3244 4.65478 17.0118C4.34222 16.6993 4.16663 16.2754 4.16663 15.8333V4.16667C4.16663 3.72464 4.34222 3.30072 4.65478 2.98816C4.96734 2.67559 5.39127 2.5 5.83329 2.5H11.6666L15.8333 6.66667V15.8333C15.8333 16.2754 15.6577 16.6993 15.3451 17.0118C15.0326 17.3244 14.6087 17.5 14.1666 17.5Z" stroke="#555D67" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  <path d="M7.5 5.83398H8.33333" stroke="#555D67" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  <path d="M7.5 10.834H12.5" stroke="#555D67" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  <path d="M10.8334 14.166H12.5" stroke="#555D67" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
</svg>;

const FileIcon = () => <svg style={{ minWidth: 20 }} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M14.9282 16.0001C15.8747 16.0001 16.6427 15.2329 16.6427 14.2856V10.8573L17.5 10.0001L16.6427 9.1428V5.71452C16.6427 4.76726 15.8755 4 14.9282 4M5.07178 4C4.12452 4 3.35726 4.76726 3.35726 5.71452V9.1428L2.5 10.0001L3.35726 10.8573V14.2856C3.35726 15.2329 4.12452 16.0001 5.07178 16.0001M7.75005 13.7501L12.2501 6.25002" stroke="#555D67" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
</svg>;

const SettingsIcon = () => <svg style={{ minWidth: 20 }} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M8.60417 3.5975C8.95917 2.13417 11.0408 2.13417 11.3958 3.5975C11.4491 3.81733 11.5535 4.02148 11.7006 4.19333C11.8477 4.36518 12.0332 4.49988 12.2422 4.58645C12.4512 4.67303 12.6776 4.70904 12.9032 4.69156C13.1287 4.67407 13.3469 4.60359 13.54 4.48583C14.8258 3.7025 16.2983 5.17417 15.515 6.46083C15.3974 6.65388 15.327 6.87195 15.3096 7.09731C15.2922 7.32267 15.3281 7.54897 15.4146 7.75782C15.5011 7.96666 15.6356 8.15215 15.8073 8.29921C15.9789 8.44627 16.1829 8.55075 16.4025 8.60417C17.8658 8.95917 17.8658 11.0408 16.4025 11.3958C16.1827 11.4491 15.9785 11.5535 15.8067 11.7006C15.6348 11.8477 15.5001 12.0332 15.4135 12.2422C15.327 12.4512 15.291 12.6776 15.3084 12.9032C15.3259 13.1287 15.3964 13.3469 15.5142 13.54C16.2975 14.8258 14.8258 16.2983 13.5392 15.515C13.3461 15.3974 13.1281 15.327 12.9027 15.3096C12.6773 15.2922 12.451 15.3281 12.2422 15.4146C12.0333 15.5011 11.8479 15.6356 11.7008 15.8073C11.5537 15.9789 11.4492 16.1829 11.3958 16.4025C11.0408 17.8658 8.95917 17.8658 8.60417 16.4025C8.5509 16.1827 8.44648 15.9785 8.29941 15.8067C8.15233 15.6348 7.96676 15.5001 7.75779 15.4135C7.54882 15.327 7.32236 15.291 7.09685 15.3084C6.87133 15.3259 6.65313 15.3964 6.46 15.5142C5.17417 16.2975 3.70167 14.8258 4.485 13.5392C4.60258 13.3461 4.67296 13.1281 4.6904 12.9027C4.70785 12.6773 4.67187 12.451 4.58539 12.2422C4.49892 12.0333 4.36438 11.8479 4.19273 11.7008C4.02107 11.5537 3.81714 11.4492 3.5975 11.3958C2.13417 11.0408 2.13417 8.95917 3.5975 8.60417C3.81733 8.5509 4.02148 8.44648 4.19333 8.29941C4.36518 8.15233 4.49988 7.96676 4.58645 7.75779C4.67303 7.54882 4.70904 7.32236 4.69156 7.09685C4.67407 6.87133 4.60359 6.65313 4.48583 6.46C3.7025 5.17417 5.17417 3.70167 6.46083 4.485C7.29417 4.99167 8.37417 4.54333 8.60417 3.5975Z" stroke="#555D67" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  <path d="M10 12.5C11.3807 12.5 12.5 11.3807 12.5 10C12.5 8.61929 11.3807 7.5 10 7.5C8.61929 7.5 7.5 8.61929 7.5 10C7.5 11.3807 8.61929 12.5 10 12.5Z" stroke="#555D67" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
</svg>;

const ChevronDownIcon = () => <svg style={{ minWidth: 20 }} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M5 7.5L10 12.5L15 7.5" stroke="#555D67" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
</svg>

const ChevronRightIcon = () => <svg style={{ minWidth: 20 }} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M7.5 5L12.5 10L7.5 15" stroke="#555D67" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
</svg>

export const CSSIcon = () => <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <rect width="20" height="20" rx="4" fill="#2965F1"/>
  <g clipPath="url(#clip0_3531_62813)">
    <path d="M5.6724 14.8004L4.70947 4H15.2905L14.3265 14.7987L9.9935 16L5.6724 14.8004Z" fill="#264DE4"/>
    <path d="M13.5013 14.1109L14.3251 4.88281H10V15.0815L13.5013 14.1109Z" fill="#2965F1"/>
    <path d="M6.91728 8.89202L7.03599 10.2166H10.0002V8.89202H6.91728ZM6.79913 7.53558H10.0002V6.21094H6.67871L6.79913 7.53558ZM10.0002 12.3322L9.99444 12.3338L8.51919 11.9354L8.4249 10.879H7.09515L7.28075 12.9588L9.99416 13.7121L10.0002 13.7104V12.3322Z" fill="#EBEBEB"/>
    <path d="M9.99561 8.89202V10.2166H11.6267L11.473 11.9346L9.99561 12.3333V13.7115L12.7112 12.9588L12.7311 12.735L13.0423 9.24771L13.0747 8.89202L13.3138 6.21094H9.99561V7.53558H11.8621L11.7416 8.89202H9.99561Z" fill="white"/>
  </g>
  <defs>
    <clipPath id="clip0_3531_62813">
      <rect width="12" height="12" fill="white" transform="translate(4 4)"/>
    </clipPath>
  </defs>
</svg>;

export const HTMLIcon = () => <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <rect width="20" height="20" rx="4" fill="#F16529"/>
  <path d="M5.96257 14.8041L5 4H15.5824L14.6198 14.7983L10.2825 16" fill="#E44D26"/>
  <path d="M10.291 15.0773V4.88281H14.6167L13.7913 14.1001" fill="#F16529"/>
  <path d="M6.96582 6.21094H10.2911V7.5352H8.41842L8.54093 8.89154H10.2911V10.2129H7.32751M7.38585 10.8779H8.71594L8.80928 11.9368L10.2911 12.3334V13.716L7.57253 12.9577" fill="#EBEBEB"/>
  <path d="M13.6046 6.21094H10.2852V7.5352H13.482M13.3625 8.89154H10.2852V10.2158H11.9186L11.764 11.9368L10.2852 12.3334V13.7102L12.9978 12.9577" fill="white"/>
</svg>;

export const JSIcon = () => <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <rect width="20" height="20" rx="4" fill="#F7DF1E"/>
  <path fillRule="evenodd" clipRule="evenodd" d="M5.50003 15.953L6.89311 15.1099C7.16186 15.5864 7.40634 15.9896 7.99277 15.9896C8.55489 15.9896 8.90928 15.7697 8.90928 14.9144V9.09785H10.62V14.9386C10.62 16.7104 9.58138 17.5169 8.0661 17.5169C6.69761 17.5169 5.90323 16.8081 5.5 15.9528" fill="black"/>
  <path fillRule="evenodd" clipRule="evenodd" d="M11.5492 15.7696L12.9421 14.9631C13.3088 15.562 13.7853 16.0018 14.6284 16.0018C15.3372 16.0018 15.7892 15.6474 15.7892 15.1586C15.7892 14.5721 15.3249 14.3643 14.5429 14.0223L14.1153 13.8389C12.8811 13.3136 12.0623 12.6537 12.0623 11.2607C12.0623 9.9776 13.0399 9 14.5674 9C15.6549 9 16.437 9.37884 16.999 10.3686L15.6671 11.224C15.3738 10.6986 15.0562 10.4909 14.5674 10.4909C14.0664 10.4909 13.7487 10.8086 13.7487 11.224C13.7487 11.7372 14.0664 11.945 14.7995 12.2627L15.2271 12.446C16.6813 13.0692 17.5 13.7046 17.5 15.1342C17.5 16.6739 16.2903 17.517 14.6651 17.517C13.0766 17.517 12.0501 16.7594 11.5492 15.7696Z" fill="black"/>
</svg>;

export const NUNIcon = () => <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <rect width="20" height="20" rx="4" fill="#1D4914"/>
  <path d="M7.46108 4V8.79869L5.9897 4H4V15.7041H6.00642V10.5878L7.4778 15.7041H9.48422V4H7.46108Z" fill="white"/>
  <path d="M13.9769 13.681H12.5055V11.5575L10.4823 12.0257V14.4501C10.4823 15.1356 11.0341 15.7041 11.7196 15.7041H14.746C15.4315 15.7041 16 15.1356 16 14.4501V6.77555H13.9769V13.681Z" fill="white"/>
</svg>;

export const JSONIcon = () => <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <rect width="20" height="20" rx="4" fill="#239F51"/>
  <path fillRule="evenodd" clipRule="evenodd" d="M4.57151 6.14301C4.57151 4.95922 5.53073 4 6.71452 4C7.2668 4 7.71452 4.44772 7.71452 5C7.71452 5.55228 7.2668 6 6.71452 6C6.6353 6 6.57151 6.06379 6.57151 6.14301V9.42853C6.57151 9.63428 6.5081 9.83349 6.39211 10C6.5081 10.1666 6.57151 10.3658 6.57151 10.5715V13.8571C6.57151 13.9363 6.63529 14.0001 6.71452 14.0001C7.2668 14.0001 7.71452 14.4478 7.71452 15.0001C7.71452 15.5524 7.2668 16.0001 6.71452 16.0001C5.53073 16.0001 4.57151 15.0409 4.57151 13.8571V10.9858L4.29289 10.7071C4.10536 10.5196 4 10.2653 4 10C4 9.73482 4.10536 9.48047 4.29289 9.29293L4.57151 9.01432V6.14301ZM12.2855 5C12.2855 4.44772 12.7332 4 13.2855 4C14.4693 4 15.4285 4.95922 15.4285 6.14301V9.01432L15.7071 9.29293C16.0976 9.68346 16.0976 10.3166 15.7071 10.7071L15.4285 10.9858V13.8571C15.4285 15.0411 14.4685 16.0001 13.2855 16.0001C12.7332 16.0001 12.2855 15.5524 12.2855 15.0001C12.2855 14.4478 12.7332 14.0001 13.2855 14.0001C13.3645 14.0001 13.4285 13.936 13.4285 13.8571V10.5715C13.4285 10.3658 13.4919 10.1666 13.6079 10C13.4919 9.83349 13.4285 9.63428 13.4285 9.42853V6.14301C13.4285 6.06379 13.3647 6 13.2855 6C12.7332 6 12.2855 5.55228 12.2855 5ZM12.0146 6.64252C12.4881 6.92667 12.6417 7.54093 12.3576 8.01451L9.35753 13.0146C9.07338 13.4881 8.45912 13.6417 7.98554 13.3576C7.51196 13.0734 7.35839 12.4591 7.64254 11.9856L10.6426 6.98552C10.9267 6.51194 11.541 6.35837 12.0146 6.64252Z" fill="white"/>
</svg>

export const FONTIcon = () => <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <rect width="20" height="20" rx="4" fill="#6A3CE2"/>
  <path fillRule="evenodd" clipRule="evenodd" d="M6.84653 4C6.856 4 6.86549 4 6.875 4L13.1535 4C13.4202 3.99998 13.6682 3.99997 13.877 4.01422C14.1023 4.02958 14.354 4.06481 14.611 4.17127C15.1624 4.39963 15.6004 4.83765 15.8287 5.38896C15.9352 5.64598 15.9704 5.89775 15.9858 6.12299C16 6.33183 16 6.57981 16 6.84653L16 6.875C16 7.42729 15.5523 7.875 15 7.875C14.4477 7.875 14 7.42729 14 6.875C14 6.57011 13.9995 6.39152 13.9904 6.25913C13.9858 6.19113 13.98 6.15796 13.9775 6.14645C13.9525 6.09151 13.9085 6.04746 13.8536 6.02246C13.842 6.02005 13.8089 6.01422 13.7409 6.00958C13.6085 6.00054 13.4299 6 13.125 6H11V14H11.875C12.4273 14 12.875 14.4477 12.875 15C12.875 15.5523 12.4273 16 11.875 16H8.125C7.57272 16 7.125 15.5523 7.125 15C7.125 14.4477 7.57272 14 8.125 14H9V6H6.875C6.57011 6 6.39152 6.00054 6.25913 6.00958C6.19113 6.01422 6.15796 6.02005 6.14645 6.02246C6.09151 6.04746 6.04746 6.09151 6.02246 6.14645C6.02005 6.15796 6.01422 6.19113 6.00958 6.25913C6.00054 6.39152 6 6.57011 6 6.875C6 7.42729 5.55229 7.875 5 7.875C4.44772 7.875 4 7.42729 4 6.875C4 6.86549 4 6.856 4 6.84653C3.99998 6.57982 3.99997 6.33183 4.01422 6.12299C4.02958 5.89775 4.06481 5.64598 4.17127 5.38896C4.39963 4.83765 4.83765 4.39963 5.38896 4.17127C5.64598 4.06481 5.89775 4.02958 6.12299 4.01422C6.33183 3.99997 6.57982 3.99998 6.84653 4Z" fill="white"/>
</svg>

export const IMAGEIcon = () => <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <rect width="20" height="20" rx="4" fill="#DB2777"/>
  <path d="M6.4 7.2C6.4 6.96266 6.47038 6.73066 6.60224 6.53332C6.73409 6.33598 6.92151 6.18217 7.14078 6.09135C7.36005 6.00052 7.60133 5.97676 7.83411 6.02306C8.06689 6.06936 8.2807 6.18365 8.44853 6.35147C8.61635 6.5193 8.73064 6.73312 8.77694 6.96589C8.82325 7.19867 8.79948 7.43995 8.70866 7.65922C8.61783 7.87849 8.46402 8.06591 8.26668 8.19776C8.06935 8.32962 7.83734 8.4 7.6 8.4C7.28174 8.4 6.97652 8.27357 6.75147 8.04853C6.52643 7.82349 6.4 7.51826 6.4 7.2ZM15.88 13.038L12.28 8.238C12.2374 8.18317 12.1828 8.1388 12.1204 8.10827C12.058 8.07775 11.9895 8.06189 11.92 8.06189C11.8505 8.06189 11.782 8.07775 11.7196 8.10827C11.6572 8.1388 11.6026 8.18317 11.56 8.238L9.16 11.34C9.13189 11.375 9.09627 11.4033 9.05577 11.4227C9.01527 11.4422 8.97092 11.4523 8.926 11.4523C8.88108 11.4523 8.83673 11.4422 8.79623 11.4227C8.75573 11.4033 8.72011 11.375 8.692 11.34L7.378 9.744C7.33583 9.69144 7.2824 9.64903 7.22165 9.61988C7.1609 9.59073 7.09438 9.5756 7.027 9.5756C6.95962 9.5756 6.8931 9.59073 6.83235 9.61988C6.7716 9.64903 6.71817 9.69144 6.676 9.744L4.126 13.038C4.04472 13.1427 4.00041 13.2714 4 13.404V13.95C4.00155 14.0689 4.04946 14.1824 4.13352 14.2665C4.21758 14.3505 4.33114 14.3984 4.45 14.4H15.55C15.6689 14.3984 15.7824 14.3505 15.8665 14.2665C15.9505 14.1824 15.9984 14.0689 16 13.95V13.398C16 13.2682 15.9579 13.1419 15.88 13.038Z" fill="white"/>
</svg>

export const FILEIcon = () => <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <rect width="20" height="20" rx="4" fill="#454C56"/>
  <path fillRule="evenodd" clipRule="evenodd" d="M10.4545 4.55395C10.4545 4.53961 10.4545 4.53243 10.4539 4.51942C10.4411 4.25009 10.2042 4.01335 9.93489 4.00061C9.92185 4 9.9176 4 9.90909 4H8.14109C7.70203 3.99999 7.33965 3.99999 7.04446 4.02411C6.73786 4.04916 6.45603 4.10292 6.19129 4.23781C5.78076 4.44698 5.44698 4.78076 5.23781 5.1913C5.10292 5.45603 5.04916 5.73786 5.02411 6.04446C4.99999 6.33965 4.99999 6.70203 5 7.14109V12.8589C4.99999 13.298 4.99999 13.6603 5.02411 13.9555C5.04916 14.2621 5.10292 14.544 5.23781 14.8087C5.44698 15.2192 5.78076 15.553 6.19129 15.7622C6.45603 15.8971 6.73786 15.9509 7.04446 15.9759C7.33966 16 7.70203 16 8.1411 16H11.6771C12.1162 16 12.4785 16 12.7737 15.9759C13.0803 15.9509 13.3621 15.8971 13.6269 15.7622C14.0374 15.553 14.3712 15.2192 14.5804 14.8087C14.7153 14.544 14.769 14.2621 14.7941 13.9555C14.8182 13.6603 14.8182 13.298 14.8182 12.8589V8.90906C14.8182 8.90059 14.8182 8.89635 14.8176 8.88336C14.8049 8.614 14.5681 8.37712 14.2987 8.36426C14.2857 8.36364 14.2786 8.36364 14.2643 8.36364H11.8553C11.7177 8.36366 11.5836 8.36368 11.4701 8.3544C11.3454 8.34421 11.1982 8.32017 11.0502 8.24474C10.8449 8.14015 10.678 7.97327 10.5735 7.76799C10.498 7.61995 10.474 7.47282 10.4638 7.34813C10.4545 7.23459 10.4545 7.10052 10.4545 6.96286V4.55395ZM7.72727 10.5455C7.42603 10.5455 7.18182 10.7897 7.18182 11.0909C7.18182 11.3922 7.42603 11.6364 7.72727 11.6364H12.0909C12.3922 11.6364 12.6364 11.3922 12.6364 11.0909C12.6364 10.7897 12.3922 10.5455 12.0909 10.5455H7.72727ZM7.72727 12.7273C7.42603 12.7273 7.18182 12.9715 7.18182 13.2727C7.18182 13.574 7.42603 13.8182 7.72727 13.8182H11C11.3013 13.8182 11.5455 13.574 11.5455 13.2727C11.5455 12.9715 11.3013 12.7273 11 12.7273H7.72727Z" fill="white"/>
  <path d="M13.677 7.27718C13.8372 7.27719 13.9173 7.27719 13.9828 7.23697C14.0755 7.18018 14.1309 7.04637 14.1055 6.94071C14.0875 6.8659 14.0353 6.81373 13.9308 6.70939L12.1132 4.89176C12.0089 4.78731 11.9567 4.73509 11.8819 4.71711C11.7762 4.69171 11.6424 4.7471 11.5856 4.83974C11.5454 4.90534 11.5454 4.98542 11.5454 5.14557V6.8408C11.5454 6.99354 11.5454 7.06991 11.5751 7.12824C11.6013 7.17956 11.643 7.22128 11.6943 7.24743C11.7527 7.27716 11.829 7.27716 11.9818 7.27716L13.677 7.27718Z" fill="white"/>
</svg>


import '../visual/index.scss';
import '../visual/menu.scss';


const getExtensionIcon = (filename) => {
  let fileExt = filename.split('.').pop();

  switch (fileExt) {
    case "png":
    case "jpg":
    case "jpeg":
    case "svg":
    case "gif":
    case "ico":
      return <HTMLIcon />;
    case "html":
      return <IMAGEIcon />;
    case "json":
      return <JSONIcon />;
    case "njk":
      return <NUNIcon />;
    case "js":
      return <JSIcon />;
    case "css":
      return <CSSIcon />;
    case "woff2":
    case "woff":
    case "ttf":
    case "eot":
      return <FONTIcon />;
    default:
      return <FILEIcon />;
    break;
  }
}




const getThemeItem = item =>
  item ? Object.values(item).sort((a, b) => a.name.localeCompare(b.name)) : [];

export const ThemeMenu = ({
  theme,
  onAddEntity,
  onFileClick,
  onSettingsClick,
  onClickShowMore,
  onDeleteFile,
  onThemeSettingsClick,
}) => {
  const transformedTheme = useMemo(() => {
    const { layouts, templates, sections, blocks, assets, snippets, locales } =
      theme;

    return {
      Layouts: getThemeItem(layouts).sort((a, b) => b.is_default - a.is_default),
      Templates: getThemeItem(templates)
        .sort((a, b) => a.template_type.localeCompare(b.template_type))
        .sort((a, b) => b.is_default - a.is_default),
      Sections: getThemeItem(sections),
      Blocks: getThemeItem(blocks),
      Snippets: getThemeItem(snippets),
      Assets: getThemeItem(assets),
      Locales: getThemeItem(locales),
    };
  }, [theme]);
  const [showImageGallery, setShowImageGallery] = useState(false);

  if (showImageGallery) {
    return <ImageGallery onBack={() => setShowImageGallery(false)} />;
  }

  return (
    <TreeView className="StyledTreeView" defaultCollapseIcon={<ChevronDownIcon />} defaultExpandIcon={<ChevronRightIcon />}>

      {Object.entries(transformedTheme).map(([key, items]) => {
        return (
          <TreeItem className="StyledTreeItem" key={key} nodeId={key}
            label={
              <div className="code-menu-label">
                <div><FolderIcon /> {key}</div>

                <Tooltip arrow title={`Add ${key.slice(0, -1)}`} placement="right">
                  <div onClick={e => onAddEntity(e, key)}>
                    <CirclePlusIcon />
                  </div>
                </Tooltip>
              </div>
            }
          >

            {items.map(item => {
              return ['Assets', 'Locales', 'Snippets'].includes(key) ? (
                <TreeItem
                    className="StyledTreeItem"
                  onClick={() => onFileClick(key, item)}
                  key={`${key}_${item.id}_template`}
                  nodeId={`${key}_${item.id}_template`}
                  label={
                    <div className="code-menu-label">
                      <div style={{ marginLeft: "-2rem" }}>
                        {
                          key === 'Snippets' ?
                            <NUNIcon /> :
                              key === 'Locales' ?
                                  <JSONIcon /> :
                            getExtensionIcon(item.name)
                        } <span style={{ whiteSpace: "nowrap", width: 170, overflow: "hidden", textOverflow: "ellipsis" }}>{`${item.name}`}</span></div>
                      <Tooltip arrow title={`Delete ${item.name}`} placement="right">
                        <div className="code-menu-label-icons" onClick={e => onDeleteFile(e, key, item)} style={{ color: "var(--red6)" }}>
                          <Trash />
                        </div>
                      </Tooltip>
                    </div>
                  }
                />
              ) : (
                  <TreeItem
                      className="StyledTreeItem"
                  key={`${key}_${item.id}`}
                  nodeId={`${key}_${item.id}`}
                  label={
                    <div className="code-menu-label">
                      <div>
                        {item.is_default ? <FolderIcon /> : null}
                        {item.name}
                      </div>

                      <Tooltip arrow title="More options" placement="right">
                        <div onClick={e => onClickShowMore(e, key, item)}>
                          <DotsIcon />
                        </div>
                      </Tooltip>
                    </div>
                  }
                >
                    <TreeItem
                        className="StyledTreeItem"
                    onClick={() => onFileClick(key, item)}
                    key={`${key}_${item.id}_file`}
                    nodeId={`${key}_${item.id}_file`}
                    label={<div className="code-menu-label">
                      <div><NUNIcon />Template.njk</div>
                    </div>}
                  />
                    <TreeItem
                        className="StyledTreeItem"
                    onClick={() => onSettingsClick(key, item)}
                    key={`${key}_${item.id}_settings`}
                    nodeId={`${key}_${item.id}_settings`}
                    label={<div className="code-menu-label">
                      <div><SettingsIcon />Settings</div>
                    </div>}
                  />
                  </TreeItem>
              );
            })}

          </TreeItem>
        );
      })}

      <TreeItem
          className="StyledTreeItem"
        sx={{
          position: "fixed",
          bottom: 61,
          borderTop: "1px solid var(--black1)",
          width: "320px"
        }}
        onClick={() => setShowImageGallery(true)}
        nodeId="image_gallery"
        label={<div className="code-menu-label extra">
          <div>
            <svg width="20" height="20" viewBox="0 0 23 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M15 8.5H15.01" stroke="#555D67" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M17 4.5H7C5.34315 4.5 4 5.84315 4 7.5V17.5C4 19.1569 5.34315 20.5 7 20.5H17C18.6569 20.5 20 19.1569 20 17.5V7.5C20 5.84315 18.6569 4.5 17 4.5Z" stroke="var(--black9)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M4 15.498L8 11.498C8.45606 11.0592 8.97339 10.8281 9.5 10.8281C10.0266 10.8281 10.5439 11.0592 11 11.498L16 16.498" stroke="var(--black9)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M14 14.498L15 13.498C15.4561 13.0592 15.9734 12.8281 16.5 12.8281C17.0266 12.8281 17.5439 13.0592 18 13.498L20 15.498" stroke="var(--black9)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            Image Library
          </div>
      </div>}
      />

      <TreeItem
          className="StyledTreeItem"
        sx={{
          position: "fixed",
          bottom: 0,
          borderTop: "1px solid var(--black1)",
          width: "320px"
      }}
        onClick={onThemeSettingsClick}
        key="theme_settings"
        nodeId="theme_settings"
        label={<div className="code-menu-label extra"><div><SettingsIcon />Theme Settings</div></div>}
      />

    </TreeView>
  );
};
